import { Button, SVG } from 'Components';
import { useNavigate } from 'react-router';
import { ROUTES, SVG_TYPE } from 'Shared/enums';
import { useEffect, useRef, useState } from 'react';
import SingleCategory from 'Screens/LoginScreens/screens/SelectCategory/components/SingleCategory/SingleCategory';
import { MainType } from './Container';
import { generatePath } from 'react-router-dom';
import { mapCategoriesByLabel } from 'Shared/utils/categoryGroups';

function MyProfileCategory(props: MainType) {
  const { actions, drivingCategories, authorizedUser } = props;
  const { getDrivingCategory, setUserCategory, getAuthorizedUser } = actions;
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState<number | null>(null);
  const [showError, setShowError] = useState(false);
  const [mappedCategories, setMappedCategories] = useState([]);
  const isMobile = window.innerWidth < 1024;
  const hasSubmittedRef = useRef(false);
  const pendingAutoSubmitRef = useRef(false);

  useEffect(() => {
    getDrivingCategory();
    getAuthorizedUser();
  }, []);

  useEffect(() => {
    const selectedId = authorizedUser?.categoryId;
    if (selectedId && drivingCategories.length > 0) {
      const category = drivingCategories.find((item) => item.value === selectedId);
      setSelectedCategory(category ? category.value : null);
    }
  }, [authorizedUser, drivingCategories]);

  const handleSubmit = async () => {
    if (selectedCategory !== null) {
      const result = await setUserCategory(selectedCategory, false);
      if (result) {
        navigate({ pathname: generatePath(ROUTES.LEARNING, { submenu: 'departments' }) });
        getAuthorizedUser();
      }
    } else {
      setShowError(true);
    }
  };

  const handleCategoryClick = (value: number) => {
    setSelectedCategory(value);
    setShowError(false);
    if (!isMobile && value !== null) {
      pendingAutoSubmitRef.current = true;
    }
  };

  useEffect(() => {
    if (isMobile) {
      return;
    }
    if (selectedCategory === null) {
      return;
    }
    if (!pendingAutoSubmitRef.current) {
      return;
    }
    if (hasSubmittedRef.current) {
      return;
    }
    hasSubmittedRef.current = true;
    pendingAutoSubmitRef.current = false;
    handleSubmit();
  }, [selectedCategory, isMobile]);

  useEffect(() => {
    setMappedCategories(mapCategoriesByLabel(drivingCategories));
  }, [drivingCategories]);

  return (
    <div className="myProfileCategory">
      <div className="myProfilePacket__top">
        <SVG type={SVG_TYPE.ADMIN_ANIMATED_ELEMENT} className="dashboard__header-animated-element dashboard__header-animated-element--first" />
        <SVG type={SVG_TYPE.ADMIN_ANIMATED_ELEMENT} className="dashboard__header-animated-element dashboard__header-animated-element--first" />
        <SVG type={SVG_TYPE.ADMIN_ANIMATED_ELEMENT} className="dashboard__header-animated-element dashboard__header-animated-element--second" />
        <span
          className={isMobile ? 'myProfilePacket__top--back' : 'myProfilePacket__top--logo--back'}
          onClick={() => navigate({ pathname: ROUTES.MYPROFILE })}>
          <SVG type={SVG_TYPE.CHEVRONE} />
        </span>
        <div className="header">Wybierz kategorię prawa jazdy</div>
      </div>

      <div className="myProfilePacket__content">
        <div className="select-category">
          <div className="select-category__group">
            <p className="single-category__label">Motory i skutery</p>
            {mappedCategories[0]?.map((category) => (
              <SingleCategory key={category.label} category={category} onClick={handleCategoryClick} selectedCategory={selectedCategory} />
            ))}
          </div>
          <div className="select-category__group">
            <p className="single-category__label">Samochody osobowe i quady</p>
            {mappedCategories[1]?.map((category) => (
              <SingleCategory key={category.label} category={category} onClick={handleCategoryClick} selectedCategory={selectedCategory} />
            ))}
          </div>
          <div className="select-category__group">
            <p className="single-category__label">Samochody ciezarowe i autobusy</p>
            {mappedCategories[2]?.map((category) => (
              <SingleCategory key={category.label} category={category} onClick={handleCategoryClick} selectedCategory={selectedCategory} />
            ))}
          </div>

          <div className="select-category__group">
            <p className="single-category__label">Ciagniki i tramwaje</p>
            {mappedCategories[3]?.map((category) => (
              <SingleCategory key={category.label} category={category} onClick={handleCategoryClick} selectedCategory={selectedCategory} />
            ))}
          </div>
        </div>
        <div className={`login-page__error-category ${showError ? 'login-page__error-category--visible' : ''}`}>Pole wymagane</div>
        <div className="myProfilePacket__buttons myProfilePacket__buttons--active myProfileCategory__buttons">
          <Button label={'Potwierdz'} className="btn--small buy" type="submit" onClick={() => handleSubmit()} />
        </div>
      </div>
    </div>
  );
}

export default MyProfileCategory;
